<template>
  <div>
    <div class="flex items-center bg-gray-800 px-2">
      <div class="flex py-4">
        <img class="w-5 h-5" src="../../assets/icons/input.svg" alt="Guid de la question" />
        <input
          v-model="guid"
          class="px-2 w-48 bg-gray-800 text-white focus:outline-none placeholder-gray-600 "
          type="text"
          placeholder="Guid de la question"
        />
      </div>
    </div>
    <button
      v-if="guid"
      @click="
        syncFromDb(guid)
        $emit('closeMenu')
      "
      class="bg-green font-light text-white text-base w-full py-3 focus:outline-none rounded-t-none rounded-lg pb-2"
    >
      Récupérer
    </button>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex"

export default {
  data() {
    return {
      guid: null,
    }
  },
  computed: {
    ...mapState({
      question_guid: (state) => state.question.guid_text,
    }),
  },
  methods: {
    ...mapActions("question", ["syncFromDb"]),
  },
  mounted() {
    this.guid = this.question_guid
  },
}
</script>

<style></style>
